import { useState } from 'react';
import styles from './Register.module.css';

const MensajeVerificacion = ({ correo, onCerrar }) => {
    const [enviando, setEnviando] = useState(false);
    const [mensajeReenvio, setMensajeReenvio] = useState('');

    const reenviarVerificacion = async () => {
        setEnviando(true);
        setMensajeReenvio('');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/reenviar-verificacion`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ correo })
            });

            const data = await response.json();

            if (response.ok) {
                setMensajeReenvio('Correo reenviado exitosamente');
            } else {
                setMensajeReenvio(data.error || 'Error al reenviar correo');
            }
        } catch (error) {
            setMensajeReenvio('Error de conexión');
        } finally {
            setEnviando(false);
        }
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2>¡Registro exitoso!</h2>
                    <button className={styles.cerrar} onClick={onCerrar}>×</button>
                </div>
                
                <div className={styles.contenido}>
                    <p>Hemos enviado un correo de verificación a:</p>
                    <p className={styles.correo}>{correo}</p>
                    <p>Por favor, revisa tu bandeja de entrada y haz clic en el enlace para verificar tu cuenta.</p>
                    
                    <div className={styles.acciones}>
                        <button 
                            className={styles.botonReenviar}
                            onClick={reenviarVerificacion}
                            disabled={enviando}
                        >
                            {enviando ? 'Enviando...' : 'Reenviar correo'}
                        </button>
                        
                        <button 
                            className={styles.botonCerrar}
                            onClick={onCerrar}
                        >
                            Entendido
                        </button>
                    </div>
                    
                    {mensajeReenvio && (
                        <p className={`${styles.mensajeReenvio} ${
                            mensajeReenvio.includes('exitosamente') ? styles.exito : styles.error
                        }`}>
                            {mensajeReenvio}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MensajeVerificacion;

